import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { LANDING_CSS } from "../../lib/publicCss";

// Shared marketing shell: injects the same design-system CSS as the landing,
// slim public nav (logo + Sign in + Start), and the same footer with the
// three Company links wired to internal React Router routes.
export const PublicShell = ({ children }) => {
  const nav = useNavigate();
  const [stuck, setStuck] = useState(false);
  useEffect(() => {
    const onScroll = () => setStuck(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="agz-landing" data-testid="public-shell">
      <style>{LANDING_CSS}</style>

      <header className={`nav${stuck ? " stuck" : ""}`}>
        <div className="wrap">
          <Link to="/" className="brand" data-testid="public-nav-logo">
            <img src="/branding/agenzee-logo.png" alt="Agenzee" />
          </Link>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <button
              className="btn btn--ghost"
              onClick={() => nav("/auth")}
              data-testid="public-nav-signin-btn">
              Sign in
            </button>
            <button
              className="btn btn--primary"
              onClick={() => nav("/auth")}
              data-testid="public-nav-cta-btn">
              Get started
            </button>
          </div>
        </div>
      </header>

      <main>{children}</main>

      <footer>
        <div className="wrap">
          <div className="fg">
            <div className="fb">
              <Link to="/" className="brand" data-testid="public-footer-logo">
                <img src="/branding/agenzee-logo.png" alt="Agenzee" />
              </Link>
              <p>The AI CMO for small business. A real media plan, grounded in your numbers. Decided, explained, produced.</p>
            </div>
            <div className="fcols">
              <div className="fcol">
                <h4>Product</h4>
                <Link to="/#how">How it works</Link>
                <Link to="/#proof">The proof</Link>
                <Link to="/#modules">Modules</Link>
                <Link to="/#faq">FAQ</Link>
              </div>
              <div className="fcol">
                <h4>Company</h4>
                <Link to="/about" data-testid="footer-about-link">About</Link>
                <Link to="/manifesto" data-testid="footer-manifesto-link">Manifesto</Link>
                <Link to="/contact" data-testid="footer-contact-link">Contact</Link>
              </div>
              <div className="fcol">
                <h4>Legal</h4>
                <Link to="/privacy" data-testid="footer-privacy-link">Privacy</Link>
                <Link to="/termini" data-testid="footer-terms-link">Terms</Link>
              </div>
            </div>
          </div>
          <div className="fbot">
            <span>© 2026 Agenzee, the agency distilled</span>
            <span>Built on Emergent</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PublicShell;
